import React from 'react';
import { Reveal } from '../Reveal';
import { useLaunchCountdown } from '../../hooks/useLaunchCountdown';
const SEATS_TAKEN = 68;
function Unit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex w-[68px] flex-col items-center sm:w-[86px]" data-id="element-288" data-mp="2bki36sakqma4">
      <span className="font-display text-4xl leading-none tabular-nums text-ink sm:text-5xl" data-id="element-289" data-mp="26knbimiz5so0">{value}</span>
      <span className="mt-2 text-[10px] font-extrabold uppercase tracking-[0.16em] text-ink/55 sm:text-xs" data-id="element-290" data-mp="33b62rzwlnjlo">
        {label}
      </span>
    </div>;
}
export function Urgency() {
  const {
    hours,
    minutes,
    seconds,
    isExpired
  } = useLaunchCountdown();
  return <section className="w-full px-4 py-10 sm:px-5 sm:py-14" aria-labelledby="urgency-title" data-id="element-291" data-mp="2ug85yhqbzmp2">
      <Reveal className="mx-auto max-w-2xl" data-id="element-292" data-mp="2ph5drxvg9ayi">
        <div className="rounded-3xl border border-lime/40 bg-rose-deep px-4 py-8 text-center shadow-[0_18px_44px_rgba(0,0,0,0.32)] sm:px-8 sm:py-10" data-id="element-293" data-mp="3mz5bl57lsgog">
          <h2 id="urgency-title" className="mx-auto max-w-xl font-display text-xl uppercase leading-tight text-white sm:text-3xl" data-id="element-294" data-mp="3i5u5j6am83xl">
            {isExpired ? 'La promoción de lanzamiento finalizó' : <>
                <span aria-hidden="true" data-id="element-295" data-mp="b7dcvclidxvm">⏰ </span>
                Precio de lanzamiento — cierra en:
              </>}
          </h2>

          {!isExpired && <div className="mt-6 flex justify-center" data-id="element-296" data-mp="18nvrm1fshgf">
              <div className="flex min-h-[104px] items-center justify-center gap-1 rounded-2xl bg-white px-4 py-4 shadow-[0_12px_30px_rgba(0,0,0,0.22)] sm:min-h-[120px] sm:gap-2 sm:px-7" role="timer" aria-live="off" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-297" data-mp="68seliptho9t">
                <Unit value={hours} label="HS" data-id="element-298" data-mp="1mntkwkuqhc8g" />
                <span className="-mt-4 font-display text-2xl text-ink/25 sm:text-3xl" aria-hidden="true" data-id="element-299" data-mp="1qp5fl4sgsnni">
                  :
                </span>
                <Unit value={minutes} label="MIN" data-id="element-300" data-mp="2zmvjz7wlmcrb" />
                <span className="-mt-4 font-display text-2xl text-ink/25 sm:text-3xl" aria-hidden="true" data-id="element-301" data-mp="2um7tqog71zy5">
                  :
                </span>
                <Unit value={seconds} label="SEG" data-id="element-302" data-mp="2qn026k8jfjib" />
              </div>
            </div>}

          <p className="mx-auto mt-6 max-w-md text-sm font-extrabold text-lime sm:text-base" data-id="element-303" data-mp="2lnvujy19htu3">
            {isExpired ? 'El precio volvió a su valor habitual. Podés acceder al Megapack cuando quieras.' : <>
                <span aria-hidden="true" data-id="element-304" data-mp="39iymwfz9yffb">⚠️ </span>
                Después sube $6.000 ARS. No vuelve.
              </>}
          </p>

          {!isExpired && <div className="mt-7 rounded-2xl bg-ink-soft px-4 py-5 sm:px-6" data-id="element-305" data-mp="5ues4qndfn4v">
              <p className="text-center text-xs font-extrabold text-white sm:text-sm" data-id="element-306" data-mp="5whrw2ebsums">
                <span className="mr-1.5 inline-block h-2 w-2 rounded-full bg-lime align-middle" aria-hidden="true" data-id="element-307" data-mp="11vclo54ihxf" />
                Cupos al precio de lanzamiento — <span className="text-lime" data-id="element-308" data-mp="dde9yrv6p6m4">quedan pocos</span>
              </p>

              <div className="mt-3.5 h-3 w-full overflow-hidden rounded-full bg-ink-line" role="progressbar" aria-valuenow={SEATS_TAKEN} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-309" data-mp="idiq2gs6jzbt">
                <div className="h-full rounded-full bg-lime" style={{
              width: `${SEATS_TAKEN}%`
            }} data-id="element-310" data-mp="wbqt96ft7wvf" />
              </div>

              <p className="mt-2 text-right text-[11px] font-extrabold text-lime sm:text-xs" data-id="element-311" data-mp="114jwtqzjkz5x">
                {SEATS_TAKEN}% tomados
              </p>
            </div>}
        </div>
      </Reveal>
    </section>;
}